import { useEffect, useState } from "react";
import { MdArrowRightAlt } from "react-icons/md";
import { useLanguage } from "../../hooks/useLanguage";

import api from "../../services/api";
import logo from '../../assets/datamar.svg';
import SkeletonInfos from "../Skeleton/SkeletonInfos";

import styles from './index.module.scss';

export default function Infos() {
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState([]);

  const { language } = useLanguage();

  const handleUploadInfo = async () => {
    const { data } = await api.get('sobre', {
      params: {
        Nome: 'Carateristicas',
        Tag: 'Carateristicas',
        Datamar: '',
        IdiomaId: language
      }
    });

    setInfo(data.value);
    setLoading(false);
  }

  useEffect(() => {
    if (!language) return;

    handleUploadInfo();
  }, [language]);

  return loading ? (
    <div className={styles.skeleton}>
      <SkeletonInfos />
    </div>
  ) : (
    <div className={styles.info}>
      <div>
        <a href="https://datamar.com.br/" target="_blank">
          <img className={styles.logo} src={logo} alt="datamar logo" />
        </a>

        <h1>{info.titulo}</h1>
      </div>

      {info?.subItens?.map(({ id, titulo, textos }) => (
        <div key={id}>
          <h2>{titulo}</h2>

          {textos?.map(({ id, texto }) => (
            <div key={id}>
              <MdArrowRightAlt />
              <p>{texto}</p>
            </div>
          ))}
        </div>
      ))}

      <h3>{info.texto}</h3>

      <p>
        <strong>{info.rodapeTitulo}</strong>
        {info.rodapeTextos.map((tel, i) => (
          <a key={i} href={`tel:${tel}`}>
            <span>
              {tel.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/gi, '$1 ($2) $3-$4')}
            </span>
          </a>
        ))}
      </p>

      <img className={styles.image} src={info.imagem} alt="imagem dados - datamar" />
    </div>
  )
}